import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';
import { Button } from './button.js';
import './input.js';
import { Textarea } from './textarea.js';

function InputGroup(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ "data-slot": "input-group", role: "group", className: cn("tw:group/input-group tw:border-input tw:dark:bg-input/30 tw:shadow-xs tw:relative tw:flex tw:w-full tw:items-center tw:rounded-md tw:border tw:outline-none tw:transition-[color,box-shadow]", "tw:h-9 tw:has-[>textarea]:h-auto", 
        // Variants based on alignment.
        "tw:has-[>[data-align=inline-start]]:[&>input]:pl-2", "tw:has-[>[data-align=inline-end]]:[&>input]:pr-2", "tw:has-[>[data-align=block-start]]:h-auto tw:has-[>[data-align=block-start]]:flex-col tw:has-[>[data-align=block-start]]:[&>input]:pb-3", "tw:has-[>[data-align=block-end]]:h-auto tw:has-[>[data-align=block-end]]:flex-col tw:has-[>[data-align=block-end]]:[&>input]:pt-3", 
        // Focus state.
        "tw:has-[[data-slot=input-group-control]:focus-visible]:ring-ring tw:has-[[data-slot=input-group-control]:focus-visible]:ring-1", 
        // Error state.
        "tw:has-[[data-slot][aria-invalid=true]]:ring-destructive/20 tw:has-[[data-slot][aria-invalid=true]]:border-destructive tw:dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40", className) }, props)));
}
cva("tw:text-muted-foreground tw:flex tw:h-auto tw:cursor-text tw:select-none tw:items-center tw:justify-center tw:gap-2 tw:py-1.5 tw:text-sm tw:font-medium tw:group-data-[disabled=true]/input-group:opacity-50 tw:[&>kbd]:rounded-[calc(var(--radius)-5px)] tw:[&>svg:not([class*=size-])]:size-4", {
    variants: {
        align: {
            "inline-start": "tw:order-first tw:pl-3 tw:has-[>button]:ml-[-0.45rem] tw:has-[>kbd]:ml-[-0.35rem]",
            "inline-end": "tw:order-last tw:pr-3 tw:has-[>button]:mr-[-0.4rem] tw:has-[>kbd]:mr-[-0.35rem]",
            "block-start": "tw:[.border-b]:pb-3 tw:order-first tw:w-full tw:justify-start tw:px-3 tw:pt-3 tw:group-has-[>input]/input-group:pt-2.5",
            "block-end": "tw:[.border-t]:pt-3 tw:order-last tw:w-full tw:justify-start tw:px-3 tw:pb-3 tw:group-has-[>input]/input-group:pb-2.5",
        },
    },
    defaultVariants: {
        align: "inline-start",
    },
});
const inputGroupButtonVariants = cva("tw:flex tw:items-center tw:gap-2 tw:text-sm tw:shadow-none", {
    variants: {
        size: {
            xs: "tw:h-6 tw:gap-1 tw:rounded-[calc(var(--radius)-5px)] tw:px-2 tw:has-[>svg]:px-2 tw:[&>svg:not([class*=size-])]:size-3.5",
            sm: "tw:h-8 tw:gap-1.5 tw:rounded-md tw:px-2.5 tw:has-[>svg]:px-2.5",
            "icon-xs": "tw:size-6 tw:rounded-[calc(var(--radius)-5px)] tw:p-0 tw:has-[>svg]:p-0",
            "icon-sm": "tw:size-8 tw:p-0 tw:has-[>svg]:p-0",
        },
    },
    defaultVariants: {
        size: "xs",
    },
});
function InputGroupButton(_a) {
    var { className, type = "button", variant = "ghost", size = "xs" } = _a, props = __rest(_a, ["className", "type", "variant", "size"]);
    return (React.createElement(Button, Object.assign({ type: type, "data-size": size, variant: variant, className: cn(inputGroupButtonVariants({ size }), className) }, props)));
}
const InputGroupTextarea = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Textarea, Object.assign({ ref: ref, "data-slot": "input-group-control", className: cn("tw:flex-1 tw:resize-none tw:rounded-none tw:border-0 tw:bg-transparent tw:py-3 tw:shadow-none tw:focus-visible:ring-0 tw:dark:bg-transparent", className) }, props)));
});
InputGroupTextarea.displayName = "InputGroupTextarea";

export { InputGroup, InputGroupButton, InputGroupTextarea };
//# sourceMappingURL=input-group.js.map
